import IconWithText from 'components/shared/IconWithText'
import { FormattedMessage, useIntl } from 'react-intl'
import iconGrill from 'assets/icons/grill.svg'
import iconMap from 'assets/icons/map.svg'
import iconRestaurant from 'assets/icons/restaurant.svg'
import Box from 'components/shared/Box'
import styled from 'styled-components'
import Link from 'components/shared/Link'
import { respondAbove } from 'styles/mediaQueries'

interface AccommodationInfoProps {
    openModal: () => void
}

const AccommodationInfoWrapper = styled(Box)`
    background: ${({ theme }) => theme.colors.grayscale_0};
    border-radius: 8px;
    > div {
        div {
            @media ${respondAbove.xl} {
                max-width: 242px;
            }
        }
    }
`

const AccommodationInfo = ({ openModal }: AccommodationInfoProps) => {
    const { formatMessage } = useIntl()

    return (
        <AccommodationInfoWrapper
            gap={[24, 32]}
            pt={[24, 40]}
            pb={[24, 40]}
            pl={[16, 40]}
            pr={[16, 40]}
        >
            <Box
                direction={['column', 'row']}
                isFullWidth={true}
                justify="space-between"
                gap={[23, 32]}
            >
                <IconWithText
                    align="flex-start"
                    icon={iconMap}
                    iconAlt="Map Icon"
                    textHighlighted={formatMessage({
                        id: 'accommodation.teaser.advantage_location',
                        defaultMessage:
                            'Dogodna lokalizacja tylko 5 minut od parku',
                    })}
                />
                <IconWithText
                    align="flex-start"
                    icon={iconRestaurant}
                    iconAlt="Bar Icon"
                    textHighlighted={formatMessage({
                        id: 'accommodation.teaser.advantage_services',
                        defaultMessage:
                            'Dodatkowe usługi, które umilą Twój pobyt',
                    })}
                />
                <IconWithText
                    align="flex-start"
                    icon={iconGrill}
                    iconAlt="Map Icon"
                    textHighlighted={formatMessage({
                        id: 'accommodation.teaser.advantage_entertainment',
                        defaultMessage: 'Otwarte strefy i place zabaw',
                    })}
                />
            </Box>
            <Link
                variant="secondary"
                onClick={openModal}
                data-testid="accommo-button-learn-more"
            >
                <FormattedMessage
                    id="accommodation.teaser.know_suntago_link"
                    defaultMessage="Poznaj Suntago Village"
                />
            </Link>
        </AccommodationInfoWrapper>
    )
}

export default AccommodationInfo
